import { useListState } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import { MailOutBoundConfigDTO } from '../../Types/MailT';
import { MailS } from '../MailS';

const preSaveConfigs = (configs: MailOutBoundConfigDTO[], imapUsage: boolean) =>
  imapUsage ? configs.filter((c) => c.usableForIMAP) : configs;

// eslint-disable-next-line import/prefer-default-export
export const useMailOutboundConfigs = (imapUsage = false) => {
  const [mailOutboundConfigs, handlers] = useListState<MailOutBoundConfigDTO>([]);
  const [loading, setLoading] = useState(false);
  const { append, setState, filter } = handlers;

  useEffect(() => {
    fetchConfigs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchConfigs = () => {
    setLoading(true);
    MailS.fetchMailOutboundConfigs()
      .then((configs) => setState(preSaveConfigs(configs, imapUsage)))
      .finally(() => setLoading(false));
  };

  const editConfig = (config: MailOutBoundConfigDTO) => {
    if (config.defaultAccount && mailOutboundConfigs.length > 1) {
      fetchConfigs();
    } else {
      setState((current) => current.map((cfg) => (cfg.id === config.id ? config : cfg)));
    }
  };

  const removeConfig = (configId: number) => filter((cfg) => cfg.id !== configId);

  return { loading, mailOutboundConfigs, append, editConfig, removeConfig, refresh: fetchConfigs };
};
